import React, { Component } from 'react';
import ClientPageBackButton from "./../ClientPageBackButton";
import ScrollToComponent from "./../ScrollToComponent";

import ksNaslovna from '../../images/ks-naslovna.jpg';

var ksNaslovnaImg = {
	backgroundPosition: "center center",
	backgroundSize: "cover",
	height: "100vh",
	backgroundImage: `url(${ksNaslovna})`
};

export default class KosiliEnglishPage extends Component {
	constructor(props) {
		super(props);
	}

	scrollNodes = [
		'#section1',
		'#section2',
		'#section3',
		'#section4',
		'#section5',
		'#section6'
	];

	render () {
		return (
			<main className="smart-page">
				<ClientPageBackButton parentThis={this} currentSlideGroup={0} path="/en" />
				<ScrollToComponent scrollNodes={this.scrollNodes}/>

				<div className="main-image-page" style={ ksNaslovnaImg }></div>
                <section id="section1" className="back-dos background-fixed kosili">
                    <div className="container-wrapper kosili-text-over3">
                        <div className="width30l">
                            <p className="first-text sun-red">PURE EMOTIONS</p>
                            <p className="zelena text top-padding">Even when we design promotional material, when we devise campaigns and activities for social media and when we jointly plan promotional appearances – we are driven by 100 per cent pure and natural emotions.</p>
                        </div>
                    </div>
                </section>
				<section id="section2" className="video-kosili">
					<div className="videoContainer-ks">
                        <iframe width="100%" height="100%" frameBorder="0" allowFullScreen
                                src="https://www.youtube.com/embed/k3VINjOqm44"/>
					</div>
				</section>
				<section id="section3" className="kosili-blue clearfix">
					<div className="container">
						<div className="kosili-blue-image">
							<img src="/img/ks-logo1.png" alt="kosili smart agency"/>
						</div>
						<div className="kosili-blue-text">
							<ul className="white text top-padding">
								<li>We really mean it when we say we have a close relationship with each and every one of our clients. </li>

								<li>However, one stands out for its gentleness, scent, and softness. People (as well as us) adore it! </li>

								<li>Collaboration with Kosili brand is especially inspiring for the women/girls in Smart Agency! Smart production team has created and devised the Kosili TV campaign and everything in connection with the marketing of this brand.</li>

								<li>We created, wrote the scenario, and produced the TV commercials, and planned their marketing campaign and media buying. </li>
							</ul></div>
					</div>
				</section>
				<section id="section4" className="image-full relative">
					<img src="/img/kosili-mom&baby.jpg" alt="kosili smart agency"/>
					<div id="section5" className="container-wrapper kosili-text-over">
						<div className="container-first padding">
							<p className="blue-text text top-padding">Citylights campaign, billboards, city buses, fair stands – all carry the same message: gentleness means love! It makes us really happy when our surroundings are painted gentle Kosili colours of love!</p>
						</div>
						<div className="container-second padding">
							<p className="first-text rose-text">KOSILI</p>
							<p className="second-text blue-text">EVERYWHERE AROUND US</p>
						</div>
					</div>
				</section>
				<section id="section6" className="image-full relative">
					<img src="/img/ks-back1.jpg" alt="kosili smart agency"/>
				</section>
			</main>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/English/KosiliEnglishPage.js